import { DialogElement } from "./theme.js";

class PartnerPopup extends DialogElement {
  connectedCallback() {
    super.connectedCallback();
    this.hidden = false;

    if (window.Shopify?.designMode) {
      this.loadDeferredImages();
      this.show(false);
      return;
    }

    if (this.hasBeenShown()) {
      return;
    }

    const remainingDelay = Math.max(0, this.apparitionDelay - (Date.now() - this.sessionStartedAt()));
    window.setTimeout(() => {
      if (!this.hasBeenShown()) {
        this.loadDeferredImages().finally(() => {
          if (!this.hasBeenShown()) {
            this.show();
          }
        });
      }
    }, remainingDelay);
  }

  loadDeferredImages() {
    if (this.deferredImagesPromise) {
      return this.deferredImagesPromise;
    }

    const images = Array.from(this.querySelectorAll("[data-partner-popup-image]"));
    const loadPromises = images.map((image) => new Promise((resolve) => {
      const finish = () => {
        image.removeEventListener("load", finish);
        image.removeEventListener("error", finish);
        resolve();
      };

      image.addEventListener("load", finish, { once: true });
      image.addEventListener("error", finish, { once: true });
      image.loading = "eager";

      if (image.dataset.srcset) {
        image.srcset = image.dataset.srcset;
        delete image.dataset.srcset;
      }

      if (image.dataset.src) {
        image.src = image.dataset.src;
        delete image.dataset.src;
      }

      if (image.complete) {
        finish();
      }
    }));

    const timeout = new Promise((resolve) => window.setTimeout(resolve, 3000));
    this.deferredImagesPromise = Promise.race([Promise.allSettled(loadPromises), timeout]);

    return this.deferredImagesPromise;
  }

  get shouldLock() {
    return true;
  }

  get shouldAppendToBody() {
    return true;
  }

  get initialFocus() {
    return this.querySelector(".partner-popup__close");
  }

  get apparitionDelay() {
    return Number.parseInt(this.getAttribute("apparition-delay"), 10) || 300000;
  }

  get storageKey() {
    return this.dataset.storageKey;
  }

  hasBeenShown() {
    try {
      return window.localStorage.getItem(this.storageKey) === "true";
    } catch {
      return false;
    }
  }

  sessionStartedAt() {
    const sessionKey = `${this.storageKey}:session-started`;

    try {
      const savedTimestamp = Number.parseInt(window.sessionStorage.getItem(sessionKey), 10);
      if (Number.isFinite(savedTimestamp)) {
        return savedTimestamp;
      }

      const timestamp = Date.now();
      window.sessionStorage.setItem(sessionKey, String(timestamp));
      return timestamp;
    } catch {
      return Date.now();
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);

    if (name === "open" && oldValue === null && newValue !== null && !window.Shopify?.designMode) {
      try {
        window.localStorage.setItem(this.storageKey, "true");
      } catch {
        // The popup still works when storage is unavailable; it simply cannot persist its shown state.
      }
    }
  }
}

if (!window.customElements.get("promotion-popup")) {
  window.customElements.define("promotion-popup", PartnerPopup);
}
